import { createTheme, ThemeOptions } from '@mui/material/styles';

export const themeOptions: ThemeOptions = {
  palette: {
    mode: 'light',
    primary: {
      main: '#6A1B9A',
    },
    secondary: {
      main: '#FF914D',
    },
  },
  typography: {
    fontFamily: '"Poppins", sans-serif',
  },
};

const theme = createTheme(themeOptions);
export default theme;